export default "__VITE_ASSET__B9qK8t0H__"